import Vue from 'vue';
import VueAuth from '@d0whc3r/vue-auth-plugin';
import VueAxios from 'vue-axios';
import axios from 'axios';
import Vuex from 'vuex';

Vue.use(VueAxios, axios);

Vue.use(Vuex);

const store = new Vuex.Store({});

//@ts-ignore
Vue.store = store;

Vue.use(VueAuth, {
  authMeta: 'auth',
  rolesVar: 'functionsRouteName',
  tokenDefaultName: 'rdkm_auth_token',
  userDefaultName: 'rdkm_auth_user',
  tokenStore: ['vuex', 'localStorage'],
  headerTokenReplace: '{auth_token}',
  tokenType: 'Bearer',

  authRedirect: '/login',

  loginData: {
    url: '/auth/login',
    method: 'POST',
    redirect: null,
    headerToken: 'Authorization',
    fetchUser: true,
    fetchData: (response: any) => response.data.data,
  },
  logoutData: { redirect: '/login' },
  fetchData: { url: '/account/me', interval:1, method: 'GET', enabled: true },
});
